import {
  PAGINATION_PREV_CLASSNAME,
  PAGINATION_NEXT_CLASSNAME,
  PAGINATION_NUMBER_CLASSNAME,
  ACTIVE_PAGINATION_NUMBER_CLASSNAME,
  TABLE_HEADER_SELECTOR,
  ASC_CLASSNAME,
  DESC_CLASSNAME,
  SCROLL_OPTIONS,
} from '../constants';

export const getPrevButtonDOM = container =>
  container.querySelector(`.${PAGINATION_PREV_CLASSNAME}`);

export const getNextButtonDOM = container =>
  container.querySelector(`.${PAGINATION_NEXT_CLASSNAME}`);

export const getAllNumberButtonsDOM = container =>
  container.querySelectorAll(`.${PAGINATION_NUMBER_CLASSNAME}`);

export const getNumberButtonDOM = (container, offset = 0) =>
  container.querySelector(`.${PAGINATION_NUMBER_CLASSNAME}[data-offset="${offset}"]`);

export const getActiveNumberButtonDOM = container =>
  container.querySelector(`.${ACTIVE_PAGINATION_NUMBER_CLASSNAME}`);

export const getTableHeaderSorter = container =>
  container.querySelectorAll('th[data-ajax-table-sorter-column]');

export const getPreviousSortedHeader = table => (
  table.querySelector(`${TABLE_HEADER_SELECTOR}.${ASC_CLASSNAME}`) ||
  table.querySelector(`${TABLE_HEADER_SELECTOR}.${DESC_CLASSNAME}`)
);

export const scrollToTop = element => element.scrollIntoView(SCROLL_OPTIONS);
